import { Resource } from "./Resource.js";
import { Bkper } from "./Bkper.js";
/**
 * This class defines a Template.
 *
 * A Template is a pre-configured setup for [[Books]] and associated Google Sheets that provides users with a starting point for specific accounting or financial management needs.
 *
 * @public
 */
export class Template extends Resource {
    constructor(json, config) {
        super(json);
        this.config = config;
    }
    /** @internal */
    getConfig() {
        return this.config || Bkper.globalConfig;
    }
    /**
     * Gets the name of the Template.
     *
     * @returns The Template's name
     */
    getName() {
        return this.payload.name;
    }
    /**
     * Gets the description of the Template.
     *
     * @returns The Template's description
     */
    getDescription() {
        return this.payload.description;
    }
    /**
     * Gets the url of the image of the Template.
     *
     * @returns The url of the Template's image
     */
    getImageUrl() {
        return this.payload.imageUrl;
    }
    /**
     * Gets the category of the Template.
     *
     * @returns The Template's category. Example: "PERSONAL", "BUSINESS", etc
     */
    getCategory() {
        return this.payload.category;
    }
    /**
     * Gets the times the Template has been used.
     *
     * @returns The number of times the Template has been used
     */
    getTimesUsed() {
        return this.payload.timesUsed || 0;
    }
    /**
     * Gets the bookId of the [[Book]] associated with the Template.
     *
     * @returns The bookId of the Book associated with the Template
     */
    getBookId() {
        return this.payload.bookId;
    }
    /**
     * Gets the link of the [[Book]] associated with the Template.
     *
     * @returns The link of the Book associated with the Template
     */
    getBookLink() {
        return this.payload.bookLink;
    }
    /**
     * Gets the link of the Google Sheets spreadsheet associated with the Template.
     *
     * @returns The link of the Google Sheets spreadsheet associated with the Template
     */
    getSheetsLink() {
        return this.payload.sheetsLink;
    }
}
//# sourceMappingURL=Template.js.map